export default __webpack_public_path__ + "static/media/systemowe.625f7cde.jpg";